import { createSlice } from "@reduxjs/toolkit";
import {
  getOrdersAgentService,
  getOrdersService,
} from "../services/orders_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,

  ordersList: [],
  metaOrders: null,
  ordersAgentList: [],
  metaOrdersAgent: {},
};

const slice = createSlice({
  name: "orders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getOrdersService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ordersList = action.payload?.data?.data?.data;
        state.metaOrders = action?.payload?.data?.data;
      })
      .addCase(getOrdersService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getOrdersService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getOrdersAgentService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ordersAgentList = action.payload?.data?.data?.data;
        state.metaOrdersAgent = action?.payload?.data?.data;
      })
      .addCase(getOrdersAgentService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getOrdersAgentService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
